import * as types from './type';

import { Faq }  from  '../../services/faq';

export function getFAQS(data) {
    return {
      type: types.GET_FAQS,
      payload: Faq.getFAQS(data),
    };
};